import {
  Button,
  Content,
  InputBox,
  Img,
  FileUploadButton,
  TextAreaBox,
  ContentLayout,
} from "@adminComponents";
import React, {useEffect, useState} from "react";
import styles from "./style.module.scss";
import {useAdminNav} from "@hook";
import {adminApi, utils} from "@utils";
import * as Datas from "@adminData";

export default function Page() {
  const {navigate} = useAdminNav();
  const [homeData, setHomeData] = useState<Datas.IInfoResponse>();
  const [clubData, setClubData] = useState<Datas.IInfoResponse>();

  async function getDetail() {
    try {
      const {data, success, message} = await adminApi.info.getHome();
      if (success) {
        const home = (data.result || []).find(item => item.type === "home");
        const club = (data.result || []).find(item => item.type === "club");
        setHomeData(home);
        setClubData(club);
      } else {
        alert(message || "오류가 발생했습니다");
      }
    } catch (error) {
      console.error("getDetail error", error);
    }
  }

  async function save() {
    try {
      const {message} = await adminApi.info.save(
        [homeData, clubData].filter(item => !!item),
      );
      alert(message);
    } catch (error) {
      console.error("saveInfo error", error);
      alert("오류가 발생했습니다.");
    }
  }

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <>
      <ContentLayout
        title="홈화면"
        rightElement={
          <div className={styles.bottomSection}>
            <Button
              backgroundColor="#d9d9d9"
              fontSize={18}
              paddingHorizontal={39}
              paddingVertical={12}
              text={"저장"}
              onClick={save}
            />
          </div>
        }>
        <Content>
          <div className={styles.content}>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                홈 상단 공지사항
              </div>
              <div className={styles.col}>
                <InputBox
                  value={homeData?.title}
                  onValue={value => {
                    setHomeData(prev => ({...prev, title: value}));
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                홈 상단 공지사항 링크
              </div>
              <div className={styles.col}>
                <InputBox
                  value={homeData?.content}
                  onValue={value => {
                    setHomeData(prev => ({...prev, content: value}));
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>

            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                카네기 클럽 사진
              </div>
              <div className={styles.col}>
                <div>
                  <FileUploadButton
                    text={"업로드"}
                    height={32}
                    width={32}
                    uploadUrl={"/api/v1/upload/info"}
                    fileUpload={data => {
                      const newFiles: Datas.IFiles[] = (data.files || [])
                        .slice(0, 1)
                        .map((item, index) => ({
                          url: item,
                          thumb_img_url: (data.thumbList || [])[index],
                        }));
                      setClubData?.(prev => ({
                        ...prev,
                        files: newFiles,
                      }));
                    }}
                  />
                </div>
              </div>
              {(clubData?.files || []).length > 0 && (
                <div className={styles.imageContainer}>
                  {(clubData?.files || []).map(
                    ({url, thumb_img_url}, index) => {
                      const imgUrl = thumb_img_url || url;
                      return (
                        <div key={index} className={styles.imageContainer}>
                          <Img src={imgUrl} className={styles.img} />
                          <div className={styles.btnContainer}>
                            {index > 0 && (
                              <div
                                className={styles.item}
                                onClick={() => {
                                  const newFiles = utils.moveArrayValue({
                                    array: clubData?.files || [],
                                    fromIndex: index,
                                    toIndex: index - 1,
                                  });
                                  setClubData?.(prev => ({
                                    ...prev,
                                    files: newFiles,
                                  }));
                                }}>
                                🔼
                              </div>
                            )}
                            <div
                              className={styles.item}
                              onClick={() => {
                                if (!confirm("이미지를 삭제하시겠습니까?")) {
                                  return;
                                }
                                setClubData(prev => ({
                                  ...prev,
                                  files: (prev?.files || []).filter(
                                    (temp, i) => i !== index,
                                  ),
                                }));
                              }}>
                              ❎
                            </div>
                            {index < (clubData?.files || []).length - 1 && (
                              <div
                                className={styles.item}
                                onClick={() => {
                                  const newImages = utils.moveArrayValue({
                                    array: clubData?.files || [],
                                    fromIndex: index,
                                    toIndex: index + 1,
                                  });
                                  setClubData(prev => ({
                                    ...prev,
                                    files: newImages,
                                  }));
                                }}>
                                🔽
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              )}
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                카네기 클럽 제목
              </div>
              <div className={styles.col}>
                <InputBox
                  value={clubData?.title}
                  onValue={value => {
                    setClubData(prev => ({...prev, title: value}));
                  }}
                  boxStyle={{flex: 1}}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                카네기 클럽 부제목
              </div>
              <div className={styles.col}>
                <TextAreaBox
                  value={clubData?.sub_title}
                  onValue={value => {
                    setClubData(prev => ({...prev, sub_title: value}));
                  }}
                  boxStyle={{flex: 1}}
                  height={100}
                />
              </div>
            </div>
            <div className={styles.row}>
              <div className={[styles.col, styles.title].join(" ")}>
                카네기 클럽 내용
              </div>
              <div className={styles.col}>
                <TextAreaBox
                  value={clubData?.content}
                  onValue={value => {
                    setClubData(prev => ({...prev, content: value}));
                  }}
                  boxStyle={{flex: 1}}
                  height={150}
                />
              </div>
            </div>
          </div>
        </Content>
      </ContentLayout>
    </>
  );
}
